// effectiveRole: the caller's PLATFORMADMIN-or-per-store-role, already resolved
// by the caller (see useCan.js) -- role is per-store now except PLATFORMADMIN,
// which stays global.
export function can(effectiveRole, allowedRoles) {
	return Boolean(effectiveRole && allowedRoles.includes(effectiveRole));
}
